export default __webpack_public_path__ + "static/media/icon_Humidity.66aac3f7.svg";